module.exports = __webpack_public_path__ + "media/images/dish-5-7707cfe90e9cdf6edc4493977703ee63.png";